import classNames from 'classnames/bind';

import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const ApiResponseExample = ({ codeExample }) => {
  const codeClass = cx('code-example-wrapper', {

  });

  const codeExampleString = (
    <>
      {Object.entries(codeExample).map((item) => {
        if (item[0] === 'source') {
          return (
            <div className={cx('numeration', 'code-example-item')} key={item[0]}>
              <span>
                {item[0]}
                :
                {' {'}
              </span>
              <div className={cx('numeration', 'code-example-item')}>
                <span className="d-flex">
                  name:&nbsp;
                  <span className="json-example-value">{item[1].name}</span>
                  ,
                </span>
                <span className="d-flex">
                  imageUrl:&nbsp;
                  <span className="json-example-value w-75">{item[1].imageUrl}</span>
                </span>
              </div>
              <span className={cx('numeration', 'brackets-numeration')}>{'},'}</span>
            </div>
          );
        }
        if (Array.isArray(item[1])) {
          return (
            <div className={cx('numeration', 'code-example-item')} key={item[0]}>
              <span>
                {item[0]}
                : [
              </span>
              <div>
                {item[1].map((subItem) => (
                  <span className={`${cx('sub-numeration')} json-example-value`} key={subItem}>
                    {subItem}
                    ,
                  </span>
                ))}
              </div>
              <span className={cx('numeration', 'brackets-numeration')}>],</span>
            </div>
          );
        }
        return (
          <div className={cx('numeration', 'code-example-item')} key={item[0]}>
            <span>
              {item[0]}
              :
            </span>
            <span className="json-example-value">{item[1]}</span>
            ,
          </div>
        );
      })}
    </>
  );

  return (
    <div className={codeClass}>
      <span className={Styles['code-title']}>
        Typical API call response
      </span>
      <pre>
        <span
          dangerouslySetInnerHTML={{ __html: '{' }}
          className={Styles.numeration}
        />
        <div>
          {codeExampleString}
        </div>
        <span
          dangerouslySetInnerHTML={{ __html: '}' }}
          className={Styles.numeration}
        />
      </pre>
    </div>
  );
};

export default withComponentName(ApiResponseExample);
